const _ = require('lodash');

function isBSN(value) {
  if (_.isNil(value)) return true;
  if (!/^\d*$/.test(value)) return false;
  if (value.length !== 8 && value.length !== 9) return false;

  const digits = value.length === 8
    ? `0${value}`.split('')
    : value.split('');

  const multiplications = [9, 8, 7, 6, 5, 4, 3, 2, -1];

  let total = 0;
  for (let i = 0; i < digits.length; i++) {
    const digit = digits[i];
    const multiplyBy = multiplications[i];
    total += digit * multiplyBy;
  }

  return total % 11 === 0;
}

module.exports = isBSN;
